import {
  IconChainUser,
  IconContractUser,
  IconCustomApi,
  IconDiscord,
  IconNFTHolder,
  IconProtocolDepositor,
  IconTelegram,
  IconTokenHolder,
  IconTwitter,
  IconVisitPage,
} from '@/assets/quest';
import React from 'react';
import {
  TwitterFollow,
  TwitterRetweet,
  TwitterQuote,
  JoinDiscord,
  JoinTelegram,
  VisitPage,
  NFTHolder,
  TokenHolder,
  ContractUser,
  ChainUser,
  ProtocolDepositor,
  CustomApi,
} from './components/ActionItem';
import { ActionType, ActionValue } from './type';

type ActionsConfigType = {
  group: string;
  groupLabel: string;
  actions: {
    type?: ActionType | ActionType[]; // 一个item有多个type的情况
    title: string;
    desc: string;
    icon: any;
    renderEditor: (setDisabled?: (val: boolean) => void) => React.JSX.Element;
    renderLabel: (value: ActionValue) => string | React.JSX.Element;
    // 动态icon
    customIcon?: string;
  }[];
};

export const QuestActionsConfig: ActionsConfigType[] = [
  {
    group: 'community',
    groupLabel: 'Community',
    actions: [
      {
        type: ['google_sheet', 'rest_api'],
        title: 'Import your own data',
        icon: IconCustomApi,
        desc: 'Supports google sheets&API',
        renderEditor: () => <CustomApi />,
        renderLabel: (value: ActionValue) => {
          return `${value?.title}`;
        },
      },
      {
        type: 'twitter_follow',
        title: 'Twitter Follower',
        icon: IconTwitter,
        desc: "Get an account's follower list",
        renderEditor: () => <TwitterFollow />,
        renderLabel: (value: ActionValue) => {
          return `[${value?.twitter_id}]-Twitter Followers`;
        },
      },
      {
        type: 'twitter_retweet',
        title: 'Twitter Retweet',
        icon: IconTwitter,
        desc: "Get a tweet's retweeter list",
        renderEditor: () => <TwitterRetweet />,
        renderLabel: (value: ActionValue) => {
          return `[${value?.twitter_id}]-Twitter Retweeters-Tweet[${value?.tweet_id}]`;
        },
      },
      {
        type: 'twitter_quote',
        title: 'Twitter Quote Tweet',
        icon: IconTwitter,
        desc: "Get a Tweet's quoter list based on users' quote contents",
        renderEditor: () => <TwitterQuote />,
        renderLabel: (value: ActionValue) => {
          const mentionStr =
            value?.min_mention_users && Number(value?.min_mention_users) > 0
              ? `&Mention ${value?.min_mention_users} friend${Number(value?.min_mention_users) > 1 ? 's' : ''}`
              : '';
          return `[${value?.twitter_id}]-Twitter Quoters${mentionStr}-Tweet[${value?.tweet_id}]`;
        },
      },
      {
        type: 'discord_member',
        title: 'Discord Member',
        icon: IconDiscord,
        desc: 'Get a Discord members list',
        renderEditor: () => <JoinDiscord />,
        renderLabel: (value: ActionValue) => {
          return `${value?.chat_name} Discord Member`;
        },
      },
      {
        type: 'link_visit',
        title: 'Visit a Page',
        desc: 'Get a list of users who visit your link',
        icon: IconVisitPage,
        renderEditor: () => <VisitPage />,
        renderLabel: (value: ActionValue) => {
          return `Visit the ${value?.name}`;
        },
      },
      {
        type: 'telegram_member',
        title: 'Join a Telegram Group / Channel',
        desc: 'Get a list of users who join your telegram group',
        icon: IconTelegram,
        renderEditor: () => <JoinTelegram />,
        renderLabel: (value: ActionValue) => {
          return `Join ${value?.chat_name} Telegram Group / Channel`;
        },
      },
    ],
  },
  {
    group: 'onChain',
    groupLabel: 'On-Chain',
    actions: [
      {
        type: 'nft_holder',
        title: 'NFT holder',
        icon: IconNFTHolder,
        desc: 'Get a list of OAT/NFT holders',
        renderEditor: () => <NFTHolder />,
        renderLabel: (value: ActionValue) => {
          return `${value?.collection_name} NFT holder`;
        },
        customIcon: 'logo_url',
      },
      {
        type: 'token_holder',
        title: 'Token holder',
        icon: IconTokenHolder,
        desc: 'Get a list of Token holders',
        renderEditor: () => <TokenHolder />,
        renderLabel: (value: ActionValue) => {
          return `${value?.token_symbol} Token holder`;
        },
        customIcon: 'logo_url',
      },
      {
        type: 'chain_user',
        title: 'Chain User',
        icon: IconChainUser,
        desc: 'Interact with specific chain',
        renderEditor: () => <ChainUser />,
        renderLabel: (value: ActionValue) => {
          return `${value?.chain_name} user`;
        },
      },
      {
        type: 'contract_user',
        title: 'Contract user',
        icon: IconContractUser,
        desc: "Interact with specific contract following poster's requirements",
        renderEditor: () => <ContractUser />,
        renderLabel: (value: ActionValue) => {
          return `${value?.contract_name} user`;
        },
      },
      {
        type: 'protocol_depositor',
        title: 'Deposit in Protocol',
        icon: IconProtocolDepositor,
        desc: 'Have assets in a specific protocol',
        renderEditor: () => <ProtocolDepositor />,
        renderLabel: (value: ActionValue) => {
          return `Deposit in ${value?.protocol_name}`;
        },
        customIcon: 'logo_url',
      },
    ],
  },
];

export const QuestActionList = QuestActionsConfig.flatMap(group => group.actions);
